import axios from 'axios';
import { push } from 'svelte-spa-router';

class HttpClient {

    baseUrl = 'https://recipe.raumkapselschweine.de';

    constructor() {

        let service = axios.create({
            baseURL: this.baseUrl
        });

        service.interceptors.response.use(this.handleSuccess, this.handleError);
        this.service = service;
    }

    handleSuccess(response) {
        return response;
    }

    handleError(error) {
        switch (error.response.status) {
            case 400:
                push('/400');
                break;
            case 404:
                push('/404');
                break;
            default:
                push('/500');
                break;
        }
        return Promise.reject(error);
    }

    async get(route, query) {
        const config = {
            params: query
        };
        return await this.service.get(route, config);
    }

    async getPaged(route, page, pageSize = 24) {
        const query = {
            page: page,
            pageSize: pageSize
        }
        return await this.get(route, query);
    }

    async post(route, data) {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return await this.service.post(route, data, config);
    }
}

export default HttpClient;